import { App } from '../../App';
import { getFetchHeaders } from '../../utils/fetchHeaders';
import { injectJuicyScript } from '../../utils/injectScript';
import { ioBlackBoxAtom } from '../../hooks/useIovation';
import { useEffect, useState } from 'react';
import { useGetClientApplication, usePutApplication } from '../../api';
import { useJuicy } from '../../hooks/useJuicy';
import { useRecoilValue } from 'recoil';
import { useResolutionResolverPhoneVerification } from './useResolutionResolverPhoneVerification';
import { useSeon } from '../../hooks/useSeon';
import RegistrationLoading from '../RegistrationLoading/RegistrationLoading';
import useAffiliateInfo from '../../hooks/useAffiliateInfo';
import useClient from '../../hooks/useClient';
import useCrossDomainLoginRedirect from '../../hooks/useCrossDomainLoginRedirect';

export default function PhoneVerificationWaiting() {
  const { affiliateInfo } = useAffiliateInfo();
  const { sendSeonFraudInfo } = useSeon();
  const { client } = useClient();
  const ioBlackBox = useRecoilValue(ioBlackBoxAtom);
  const [attempts, setAttempts] = useState(1);
  const { crossDomainLoginRedirect } = useCrossDomainLoginRedirect();
  const { generateJuicyApplicationSession } = useJuicy();

  const apiGetClientApplication = useGetClientApplication();
  const { fetch: fetchPutApplication } = usePutApplication();
  const apiAffiliateEventQualified = App.useApi(
    'affiliate-events/qualified',
    'POST',
  );
  const { fetch: fetchUpdateAffiliate } = App.useApi(
    'client/affiliate',
    'POST',
  );

  // useEffect to throw affiliates calls
  useEffect(() => {
    injectJuicyScript();
    const affiliateCalls = async () => {
      try {
        try {
          await sendSeonFraudInfo();
        } catch {}

        if (affiliateInfo.provider) {
          await fetchUpdateAffiliate({
            body: affiliateInfo,
          });
        }

        if (client?.isRegisteredByAffiliate) {
          await apiAffiliateEventQualified.fetch({
            headers: getFetchHeaders(),
          });
        }
      } catch {}
    };
    affiliateCalls();
  }, [affiliateInfo.provider, client?.isRegisteredByAffiliate]);

  // useffect to confirm the application
  useEffect(() => {
    const confirmationCall = async () => {
      if (
        !apiGetClientApplication.data?.confirmed &&
        apiGetClientApplication.data?.status === 'OPEN'
      ) {
        try {
          await fetchPutApplication({
            body: {
              ioBlackBox,
            },
          });
          await apiGetClientApplication.fetch();
          await generateJuicyApplicationSession();
        } catch {
          if (attempts > 3) {
            // Force re-login
            crossDomainLoginRedirect('dashboard', false);
          } else {
            setTimeout(() => setAttempts(attempts + 1), 1000);
          }
        }
      }
    };

    confirmationCall();
  }, [attempts, apiGetClientApplication.data?.confirmed]);

  useResolutionResolverPhoneVerification();

  return <RegistrationLoading />;
}
